<div class="container mx-auto p-6">
  <div class="flex justify-between items-center mb-6">
    <h1 class="text-2xl font-semibold text-gray-800 dark:text-white/90">
      {{ venue?.name }} - Daily Prices
    </h1>
    <app-button
      [label]="'Back to Venue'"
      [icon]="BackIcon"
      [style]="'secondary'"
      [routerLink]="['/venues', venue?.id, 'edit']">
    </app-button>
  </div>

  <div class="bg-white dark:bg-white/[0.03] rounded-lg shadow-sm p-4 border border-gray-200 dark:border-gray-800">
    <full-calendar [options]="calendarOptions">
    </full-calendar>
  </div>
</div>
